import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from './main';
import Listimageall from './listimageall';
import Imagess from './image';
import ManageImages from './manageimages'; // นำเข้า ManageImages

const App = () => {
  return (
    <>
      <Routes>
        <Route path="/*" element={<Main />} />
        <Route path="/Imagess" element={<Imagess />} />
        <Route path="/imaglistall" element={<Listimageall />} />
        <Route path="/manage-images" element={<ManageImages />} /> {/* เส้นทางใหม่สำหรับการจัดการรูป */}
      </Routes>
    </>
  );
};

export default App;
